import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_USER_IN_2N } from 'services/2n/get-user';
import { useContext } from 'react';
import { ALL_USERS } from '../get-all-users';
import { USER_PERMISSIONS_BY_EMAIL } from '../../user/permissions/permissions-by-email';
// eslint-disable-next-line max-len
import { UserAdministrationModalContext } from '../../../components/brikks/home/UserAdministration/components/UserAdministrationModal/UserAdministrationModalContext';
import { enableUserAPI } from './api';

export function useEnableUser({ onSuccess }) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();
  const { selectedUser } = useContext(UserAdministrationModalContext);

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (userId) => enableUserAPI(userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        queryClient.invalidateQueries([GET_USER_IN_2N, tenantId]);
        queryClient.invalidateQueries([USER_PERMISSIONS_BY_EMAIL, selectedUser?.email]);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      },
    },
  );

  return {
    mutate,
    mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}
